export default {
  title: 'מצטערים, אין לך גישה למערכת',
  tipsTitle:
    'הכניסה למערכת היא עבור משתמש CARWIZ PRO בלבד, אם הינך משתמש כזה והודעה זו הופיעה ניתן לנסות את הפעולות הבאות:',
  tips: ['כניסה באמצעות מספר טלפון אחר', 'ליצור איתנו קשר  בinfo@carwiz.co.il']
};
